export default __webpack_public_path__ + "static/media/pelattava-arpa.13faf74a.png";